import { render, staticRenderFns } from "./BaseChatList.vue?vue&type=template&id=d8a61eac&lang=pug"
import script from "./BaseChatList.vue?vue&type=script&lang=ts"
export * from "./BaseChatList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports